import React, { Component, Fragment } from "react";
import AuthService from "../../Auth/Autenticacao/services/auth.service";
import './style.css';

export default class Sidebar extends Component {

    constructor(props) {
        super(props);

        let usuarioAtual = AuthService.getCurrentUser();

        this.state = {
            aplicationName: "Sidebar",
            isAdmin: !!(usuarioAtual && usuarioAtual.roles && usuarioAtual.roles.includes("ROLE_ADMIN"))
        }
    }

    render() {
        return(
            <Fragment>
                <div className="sidebar" data-color="white" data-active-color="danger">
                    <div className="logo">
                        <a href="/dashboard">
                            <img src="/assets/images/senai_logo_negativo.png" alt="SENAI" className="logo-img" />
                        </a>
                    </div>
                    <div className="sidebar-wrapper">
                        {/*
                        <ul className="nav">
                            <li>
                                <a href="/dashboard">
                                <i className="nc-icon nc-bank"></i>
                                <p>Painel</p>
                                </a>
                            </li>
                            <li>
                                <a href="/unidade">
                                <i className="nc-icon nc-pin-3"></i>
                                <p>Unidades</p>
                                </a>
                            </li>
                            <li>
                                <a href="/relatorios">
                                <i className="nc-icon nc-tile-56"></i>
                                <p>Relatórios</p>
                                </a>
                            </li>
                            <li>
                                <a href="/sti">
                                <i className="nc-icon nc-tile-56"></i>
                                <p>STI</p>
                                </a>
                            </li>
                        </ul>
                        */}
                        <ul className="nav">
                            <li>
                                <a href="/educacao">
                                <i className="nc-icon nc-bank"></i>
                                <p>Educação 2027</p>
                                </a>
                            </li>
                            {/* <li>
                                <a href="/sti">
                                <i className="nc-icon nc-tile-56"></i>
                                <p>STI</p>
                                </a>
                            </li> */}
                            {/* <li>
                                <a href="/v2/sti">
                                <i className="nc-icon nc-tile-56"></i>
                                <p>STI</p>
                                </a>
                            </li> */}
                            <li>
                                <a href="/sti">
                                <i className="nc-icon nc-tile-56"></i>
                                <p>STI 2027</p>
                                </a>
                            </li>
                            {this.state.isAdmin && (
                                <Fragment>
                                    <li>
                                        <a href="/admin/usuarios">
                                        <i className="nc-icon nc-single-02"></i>
                                        <p>Usuários</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/admin/logs">
                                        <i className="nc-icon nc-single-copy-04"></i>
                                        <p>Logs</p>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/admin/prazo">
                                        <i className="nc-icon nc-time-alarm"></i>
                                        <p>Prazo de edição</p>
                                        </a>
                                    </li>
                                </Fragment>
                            )}
                        </ul>
                    </div>
                </div>
            </Fragment>
        )
    }
}